import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "sound-source-controls" }
const _hoisted_2 = { class: "gain" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "frequency" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EffectSelect = _resolveComponent("EffectSelect")!
  const _component_RangeEffectControl = _resolveComponent("RangeEffectControl")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['sound-source-component', _ctx.oscTypeClass])
  }, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.oscType), 1),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRemove && _ctx.handleRemove(...args)), ["prevent"]))
      }, "Remove"),
      _withDirectives(_createElementVNode("button", {
        ref: "muteBtn",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleMute && _ctx.handleMute(...args)), ["prevent"]))
      }, " Mute ", 512), [
        [_vShow, !_ctx.activeOsc.isMuted]
      ]),
      _withDirectives(_createElementVNode("button", {
        ref: "unmuteBtn",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUnMute && _ctx.handleUnMute(...args)), ["prevent"]))
      }, " Unmute ", 512), [
        [_vShow, _ctx.activeOsc.isMuted]
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("button", null, "Duplicate", -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("label", { for: "gain" }, "Gain", -1)),
      _createElementVNode("input", {
        name: "gain",
        ref: "gainCtrl",
        type: "range",
        min: "0",
        max: "1",
        step: "any",
        value: _ctx.activeOsc.gain,
        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleGainChange && _ctx.handleGainChange(...args)))
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[9] || (_cache[9] = _createElementVNode("label", { for: "frequency" }, "Frequency:", -1)),
      (_ctx.oscType === 'Osc - low')
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            name: "frequency",
            ref: "freqCtrl",
            type: "range",
            min: "45",
            max: "120",
            step: "0.01",
            onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFreqChange && _ctx.handleFreqChange(...args)))
          }, null, 544))
        : _createCommentVNode("", true),
      (_ctx.oscType === 'Osc - mid')
        ? (_openBlock(), _createElementBlock("input", {
            key: 1,
            name: "frequency",
            ref: "freqCtrl",
            type: "range",
            min: "121",
            max: "1400",
            step: "0.01",
            onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleFreqChange && _ctx.handleFreqChange(...args)))
          }, null, 544))
        : _createCommentVNode("", true),
      (_ctx.oscType === 'Osc - high')
        ? (_openBlock(), _createElementBlock("input", {
            key: 2,
            name: "frequency",
            ref: "freqCtrl",
            type: "range",
            min: "1401",
            max: "15000",
            step: "0.01",
            onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleFreqChange && _ctx.handleFreqChange(...args)))
          }, null, 544))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_EffectSelect, {
      availableEffects: _ctx.availableEffects,
      onSelectEffect: _ctx.handleEffectSelected
    }, null, 8, ["availableEffects", "onSelectEffect"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeEffects, (effect, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "effect",
        key: effect.name
      }, [
        (effect.controlType === 'range')
          ? (_openBlock(), _createBlock(_component_RangeEffectControl, {
              key: i,
              effect: effect,
              audioContext: _ctx.audioContext,
              effectNode: _ctx.getEffectNode(effect.name),
              onEffectRemoved: _ctx.handleRemoveEffect
            }, null, 8, ["effect", "audioContext", "effectNode", "onEffectRemoved"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 2))
}